import { render } from "./NewCase.vue?vue&type=template&id=c2aac502&scoped=true"
import script from "./NewCase.vue?vue&type=script&lang=js"
export * from "./NewCase.vue?vue&type=script&lang=js"

import "./NewCase.vue?vue&type=style&index=0&id=c2aac502&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2aac502"]])

export default __exports__